import React from "react";
import { Table } from "reactstrap";
import { Link } from "react-router-dom";

function formatElapsedTime(seconds) {
  if (!seconds && seconds !== 0) return "-";

  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
}

// Rows are keyed on public_id, the only stable per-camera identity: the slot
// number is unique per capture device, not per store, so two devices in the same
// store can both expose a slot 1.
function CamerasInSimulationTable({ cameras }) {
  if (!cameras || cameras.length === 0) {
    return <p className="font-bold text-white">No cameras in simulation</p>;
  }

  return (
    <Table className="tablesorter" responsive>
      <thead className="text-primary">
        <tr>
          <th>Slot</th>
          <th>Capture Device</th>
          <th>Location</th>
          <th>Since</th>
        </tr>
      </thead>
      <tbody>
        {cameras.map((camera) => (
          <tr key={camera.public_id}>
            <td>{camera.slot_number}</td>
            <td>{camera.device ? `${camera.device.host}:${camera.device.port}` : "-"}</td>
            <td>
              {camera.store_location && camera.store_id ? (
                <Link to={`/stores/${camera.store_id}`}>{camera.store_location}</Link>
              ) : (
                camera.store_location || "-"
              )}
            </td>
            <td>{formatElapsedTime(camera.elapsed_time)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default CamerasInSimulationTable;
